import { usePhoneCampaign } from '@hc-frontend/core-ui';
import { CallCta } from '@hc-frontend/shells-shared';

export default function CallCampaignButton() {
  const phoneCampaign = usePhoneCampaign();

  if (phoneCampaign) {
    return (
      <>
        <CallCta phoneCampaign={phoneCampaign} className="text-center text-2xl">
          {phoneCampaign.phoneNumber}
        </CallCta>
        <p>{phoneCampaign.todayTTY}</p>
      </>
    );
  }
  return null;
}
